export const environment = {
  production: true,
  buildId: '3385363597322001',
  configFile: 'config.json',
};
